export default async () => {
  const resp = await fetch(`${CDN_HOST}/app-config.json?v=${APP_VERSION}`);

  if (resp.ok) {
    const json = await resp.json();
    return json;
  }

  return null;
};